import api, { URLS } from "@/services/api.js";

const BASE_URL_EFM = URLS.API_FGTAS;

export const verificarDisponibilidadeApiEfm = () => {
	const url = `${BASE_URL_EFM}/verifica-disponibilidade`;
	return api.get(url);
};
